import type { Crop } from 'core/utils/basic.models';
import { icons } from './crop-icon.constants';

export const getSFCropIconName = (cropInfo: Crop | undefined) => {
  const cropSlug: string = cropInfo?.wk_slug?.toLowerCase().replace(/\s+/g, '') ?? '';
  return icons[cropSlug] || 'phenology';
};
